import { useTranslation } from 'react-i18next'

import { FormFieldsContainer } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_NAME_NAME,
  REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_QA_NAME,
  REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_NAME_MAX_LENGTH,
} from '../RequestProfileTabActivitiesAddPhaseModal.constants'

function RequestProfileTabActivitiesAddPhaseModalFields() {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikField
        autoFocus
        clearable
        hasCounter
        required
        Component={InputField}
        label={t('RequestProfileTabActivities.AddPhaseModalNameLabelKey')}
        maxLength={
          REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_NAME_MAX_LENGTH
        }
        name={REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_NAME_NAME}
        placeholder={t(
          'RequestProfileTabActivities.AddPhaseModalNamePlaceholderKey'
        )}
        qaName={REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_QA_NAME}
      />
    </FormFieldsContainer>
  )
}

export default RequestProfileTabActivitiesAddPhaseModalFields
